var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWasherFluid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5646 12.1669C7.12953 9.30115 10.8538 7.5 15 7.5C19.1462 7.5 22.8705 9.30115 25.4354 12.1669C25.8037 12.5784 26.4359 12.6135 26.8474 12.2451C27.259 11.8768 27.294 11.2446 26.9257 10.8331C23.9974 7.56135 19.7388 5.5 15 5.5C10.2612 5.5 6.00261 7.56135 3.07433 10.8331C2.70601 11.2446 2.74103 11.8768 3.15255 12.2451C3.56408 12.6135 4.19628 12.5784 4.5646 12.1669ZM10.7995 19.6001C11.759 18.3229 13.2833 17.5 15 17.5C16.7167 17.5 18.241 18.3229 19.2005 19.6001C19.5323 20.0416 20.1591 20.1306 20.6007 19.7989C21.0422 19.4671 21.1312 18.8403 20.7995 18.3987C19.4785 16.6404 17.3723 15.5 15 15.5C12.6277 15.5 10.5216 16.6404 9.20052 18.3987C8.86878 18.8403 8.95779 19.4671 9.39934 19.7989C9.84089 20.1306 10.4678 20.0416 10.7995 19.6001Z",
    fill: "#2B2B2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.477 12.2805C21.8508 12.4736 21.9974 12.9332 21.8044 13.3071L17.6021 21.4449C17.4091 21.8187 16.9495 21.9653 16.5756 21.7723C16.2017 21.5792 16.0551 21.1196 16.2482 20.7457L20.4504 12.6079C20.6435 12.234 21.1031 12.0875 21.477 12.2805Z",
    fill: "#2B2B2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 21.25C14.8096 21.25 14.25 21.8096 14.25 22.5C14.25 23.1904 14.8096 23.75 15.5 23.75C16.1904 23.75 16.75 23.1904 16.75 22.5C16.75 21.8096 16.1904 21.25 15.5 21.25ZM13 22.5C13 21.1193 14.1193 20 15.5 20C16.8807 20 18 21.1193 18 22.5C18 23.8807 16.8807 25 15.5 25C14.1193 25 13 23.8807 13 22.5Z",
    fill: "#2B2B2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20.5V8.5",
    stroke: "#2B2B2C",
    strokeLinecap: "round",
    strokeDasharray: "1 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19L4 11.5M20 19L26 11.5",
    stroke: "#2B2B2C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7C16.1667 6 18 4 20 4C22.5 4 24.5 6.5 24.5 7",
    stroke: "#2B2B2C",
    strokeLinecap: "round",
    strokeDasharray: "1 2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7C15.3333 6 13.5 4 11.5 4C9 4 7 6.5 7 7",
    stroke: "#2B2B2C",
    strokeLinecap: "round",
    strokeDasharray: "1 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasherFluid);
export default __webpack_public_path__ + "static/media/WasherFluid.00439b28173fe5733e962c1305ad69c7.svg";
export { ForwardRef as ReactComponent };